import { render, staticRenderFns } from "./InfoMaterials.vue?vue&type=template&id=d5ed3ac0&scoped=true&"
import script from "./InfoMaterials.vue?vue&type=script&lang=js&"
export * from "./InfoMaterials.vue?vue&type=script&lang=js&"
import style0 from "./InfoMaterials.vue?vue&type=style&index=0&id=d5ed3ac0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5ed3ac0",
  null
  
)

export default component.exports